export default class ValidatorsUtils {
  static validateDecimal(value: number): boolean {
    if (!value) {
      return true;
    }

    return value.toString().split('.').length === 1;
  }

  static validatePrice(value: number, maxDecimals = 2): boolean {
    const decimalPattern = `(\\.\\d{1,${maxDecimals}})?`;

    const regex = new RegExp(`^\\d+${decimalPattern}$`);

    return regex.test(value.toString());
  }
}
